<template>
    <div>
        <main class="main" v-if="Produto!=''">
            <div class="slider-area ">
                <div class="single-slider hero-overly slider-height2 d-flex align-items-center"
                    v-if="informacoestopo != '' && informacoestopo[0].insInstitucionalImagens != ''"
                    :style="{ backgroundImage: 'url(' + $imgURL + informacoestopo[0].insInstitucionalImagens[0].itgUrlImagem + ')', backgroundSize: 'cover', height: '450px' }">
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-12">
                                <div class="hero-cap pt-60" style="text-align: center;">
                                    <h2 style="color:#ffffff;">
                                       {{Produto.proNomeProduto}} {{Produto.proReferencia}}</h2>

                                    <!--nav aria-label="breadcrumb ">
                                        <ol class="breadcrumb">
                                            <li class="breadcrumb-item"><router-link to="/"
                                                    style="color:#000000;">Home</router-link></li>
                                            <li class="breadcrumb-item"><a href="#" style="color:#000000;">Produtos</a></li>
                                        </ol>
                                    </!--nav-->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-content pt-6">
                <div class="container">
                    <div class="row">
                        <div class="col-md-3">
                            <aside>
                            <div class="sidebar sidebar-shop">
                                <div class="widget widget-collapsible">
                                    <h3 class="widget-title">
                                        Categorias
                                    </h3><!-- End .widget-title -->
                                    <router-link v-if="$route.fullPath.includes('ProdutosPesquisa')"
                                        to="/produtos/1/Produtos" class="btn btn-info"
                                        style="color:#FFF">Voltar</router-link>
                                    <div class="collapse show" id="widget-1">
                                        <div class="widget-body">
                                            <div v-for="seg in SegmentosMenu" :key="seg.psgId" style="line-height: 2;">
                                                <div
                                                    style="line-height: 1.3; border: 1px solid #cccccc; padding: 10px; display: flex; align-items: center;">
                                                    <router-link :to="'/produtos/' + seg.psgId + '/' + seg.psgNomeSegmento.replaceAll(' ', '-').replaceAll('/', '').replaceAll(',', '')"
                                                        style="display: flex; align-items: center;">
                                                        <img v-if="seg.psgResumo !== '' && seg.psgResumo !== null"
                                                            :src="$imgURL + seg.psgResumo" class="swiper-image"
                                                            :alt="seg.psgNomeSegmento" :title="seg.psgNomeSegmento"
                                                            style="width: 50px; height: auto; border-radius: 50px; margin-right: 8px;" />

                                                        <img v-else
                                                            src="http://front.seletoindustrial.kinghost.net/images/userNo.png"
                                                            style="width: 50px; height: auto; border-radius: 50px; margin-right: 8px;"
                                                            :alt="seg.psgNomeSegmento" :title="seg.psgNomeSegmento" />

                                                        <span
                                                            style="font-weight: 500; font-size: 14px; color: #333333;">
                                                            {{ seg.psgNomeSegmento }}
                                                        </span>
                                                    </router-link>
                                                </div>
                                            </div>
                                        </div>

                                    </div><!-- End .collapse -->
                                </div><!-- End .widget -->
                            </div><!-- End .sidebar sidebar-shop -->
                             </aside><!-- End .col-lg-3 -->
                        </div>
                        <div class="col-md-9">
                            <div class="product-details-top mb-2">
                            <div class="row" style="padding-bottom: 30px;">
                            <div class="col-md-6">
                                <div class="product-gallery product-gallery-vertical">
                                    <div class="row" v-if="ProdutoImg && ProdutoImg.length">
                                        <!-- Imagem Principal -->
                                        <a href="#" @click.prevent="show(ProdutoImg,0)">
                                            <img :src="ProdutoImg[0].pimUrlImagem" alt="" style="width: 100%;">
                                        </a>                                       
                                    </div>

                                    <!-- Thumbnails -->
                                    <div class="row mt-2 d-flex justify-content-center" v-if="ProdutoImg.length > 1">
                                        <div v-for="(img, index) in ProdutoImg.slice(1)" :key="img.pimUrlImagem" class="thumb">
                                            <a href="#" @click.prevent="show(ProdutoImg, index + 1)">
                                                <img :src="img.pimUrlImagem" alt="" style="width: 60px; height: 60px; margin: 5px; cursor: pointer;">
                                            </a>
                                        </div>
                                    </div>
                                </div><!-- End .product-gallery -->
                            </div><!-- End .col-md-6 -->

                            <div class="col-md-6">
                                <div class="product-details product-details-centered">
                                    <h1 class="product-title" style="color: #020230;margin-bottom: 0px !important;font-weight: 500;">{{Produto.proNomeProduto}} </h1>
                                    <div v-if="Produto.proReferencia!=''" style="font-size: 14px;color:#333333;">Ref: {{Produto.proReferencia}}</div><!-- End .product-title -->
                                    <div v-if="Produto.proTempoProducao!='' && Produto.proTempoProducao!=0" style="font-size: 14px;color:#333333;">EAN: {{Produto.proTempoProducao}}</div><!-- End .product-title -->
                                    <p><a :href="Produto.proCampoExtra10" target="_blank" style="color:#020230">Detalhes Técnicos</a></p>

                                    <div class="product-details-action" style="padding-top: 10px;">
                                        <div class="details-action-col">
                                            <a href="#" @click="openDialog(Produto)" class="btn btn-product btn-cart">Quero Orçamento</a>
                                        </div><!-- End .details-action-col -->
                                    </div><!-- End .product-details-action -->
                                    <div class="row">
                                        <div class="col-lg-12 pb-3" style="padding: 20px;">
                                            <p v-html="Produto.proTexto1"></p>
                                            <p v-html="Produto.proTexto2"></p>
                                        </div>
                                     </div>

                                    <div class="product-details-action" style="padding-top: 10px;">
                                        <div class="details-action-col">
                                            <a href="#"  @click="openDialog(Produto)" class="btn btn-product btn-cart">Quero Orçamento</a>
                                        </div><!-- End .details-action-col -->
                                    </div><!-- End .product-details-action -->
                                </div><!-- End .product-details -->
                            </div><!-- End .col-md-6 -->
                                </div><!-- End .row -->
                            </div><!-- End .product-details-top -->
                            <section style="padding: 10px;background-color: #f7f7f7;padding-bottom: 60px;">
                                <div class="container">
                                    <div class="row">
                                        <div class="col-md-12 mb-5" style="text-align: center;">
                                            <h2 class="" style="color:#000000;">Detalhes do Produto</h2>
                                        </div>
                                            <div class="col-md-12">
                                                <v-table>
                                                    <thead>
                                                    <tr style="background-color: #ccc;font-weight: 500;">
                                                        <th class="text-left">
                                                            Título
                                                        </th>
                                                        <th class="text-left">
                                                            Características
                                                        </th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr
                                                        v-for="(item, index) in Produto.proProdutosGrids" :key="item.pgsId" :class="{'cortable': index % 2 === 0}"
                                                    >
                                                        <td>{{ item.pgsNome }}</td>
                                                        <td>{{ item.pgsCampoExtra1 }}</td>
                                                    </tr>
                                                    </tbody>
                                                </v-table>
                                            </div>
                                            <div class="col-md-12">
                                                <div v-if="Produto.proCampoExtra5 !=''" style="padding-top: 0px">
                                                    <iframe  width="100%" height="415" :src="Produto.proCampoExtra5" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                                                </div>
                                            </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div><!-- End .container -->

                <div v-if="infocall!=''" class="cta bg-image bg-dark" :style="{backgroundImage: 'url(' + $imgURL + infocall[0].insInstitucionalImagens[0].itgUrlImagem + ')', backgroundSize: 'cover', paddingTop: '40px', paddingBottom:'40px'}">
                    <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-sm-10 col-md-8 col-lg-6">
                        <div class="cta-text text-center">
                            <h2 class="cta-title text-white fontcallT">{{infocall[0].itiNome}}</h2><!-- End .cta-title -->
                            <p class="cta-desc text-light2 fontcallS" v-html="infocall[0].itiResumo1" style="color: #fff !important;padding-bottom: 20px;"></p><!-- End .cta-desc -->

                            <a href="#" @click="openDialog(Produto)" class="btn btn-primary btn-rounded" style="background-color: #007bff !important"><span>{{infocall[0].itiTextoBtn1}}</span><i
                                class="icon-long-arrow-right"></i></a>
                        </div><!-- End .cta-text -->
                        </div><!-- End .col-sm-10 col-md-8 col-lg-6 -->
                    </div><!-- End .row -->
                    </div><!-- End .container -->
                </div><!-- End .cta -->
            </div><!-- End .page-content -->
        </main>
        <div class="images" v-viewer>
            <img v-for="src in images" :key="src" :src="src">
        </div>
    </div>
    <v-dialog v-model="dialog" max-width="600px" persistent>
            <v-card>
                <v-card-subtitle class="text-center" style="padding-top: 30px">Preencha os dados abaixo para nossa
                    equipe
                    comercial</v-card-subtitle>

                <v-card-text>
                    <v-form>
                        <v-row>
                            <v-col cols="6">
                                <v-text-field label="Nome" v-model="form.name" required></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field label="E-mail" v-model="form.email" required></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="6">
                                <v-text-field label="Empresa" v-model="form.company" required></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field label="Celular com DDD" v-model="form.mobile" required type="number"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row v-show="false">
                            <v-col cols="8">
                                <v-text-field label="Cidade" v-model="form.cityName" required></v-text-field>
                            </v-col>
                            <v-col cols="4" v-show="false">
                                <v-text-field label="UF" v-model="form.cityState" maxlength="2" required></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <v-textarea label="Mensagem" v-model="form.message" maxlength="140"
                                    rows="3"></v-textarea>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialog = false">Cancelar</v-btn>
                    <v-btn class="btn btn-small" style="color:#ffffff" @click="submitForm">Enviar dados</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
</template>

<script>
//import moment from 'moment'
import axios from 'axios';
import { useRoute } from 'vue-router';
import { useHead } from '@vueuse/head';
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';

export default {
    name: 'ProdutosDetalheView',
    setup() {
        const route = useRoute();
        const id = route.params.idProduto;
        const nomeProduto = route.params.nomeProduto;
        return {
            id
        };
    },
    components: {
        Viewer
    },
    data: () => ({
        informacoestopo: [],
        Produto: [],
        ProdutoImg:[],
        infocall:[],
        valorTotal:0,
        vProdutosExtras:[],
        ProdutoAvulsos:[],
        DadosCompra: {
            produtos: [],
            mensagem: [],
            agenda: [],
            foto: [],
            avulsos: [],
            baloes: [],
            informacao: [],
            pagamento: [],
            cupom: [],
        },
        activeIndex: 0, // Índice inicial da imagem ativa na galeria
        imagesForGallery: [], // Array de imagens para a galeria
        viewerOptions: {},
         //modal
         dialog: false,
        selectedItem: null,
        form: {
            title: '',
            hash: '',
            origin: '',
            name: '',
            company: '',
            email: '',
            mobile: '',
            cityName: '',
            cityState: '',
            message: '',
            public_url: '',
        },
        SegmentosMenu: [],
    }),
    methods: {
        submitForm() {
            if (this.form.name == '' || this.form.name == null){
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.form.email == '' || this.form.email == null){
                this.$mensagemAviso("E-mail Obrigatório.")
            }
            else if (this.form.company == '' || this.form.company == null){
                this.$mensagemAviso("Empresa Obrigatório.")
            }
            else if (this.form.mobile == '' || this.form.mobile == null){
                this.$mensagemAviso("Whatsapp ou Telefone Obrigatório.")
            }
            else
            {
                // Montando o JSON para envio
                const payload = {
                rules: {
                    update: false,
                    validate_cpf: false,
                    validate_cnpj: false,
                    equal_pipeline: false
                },
                leads: [
                    {
                        id: this.form.email,
                        name: this.form.name,
                        email: this.form.email,
                        title: this.form.name, 
                        company: this.form.company,
                        city_name: '',
                        city_state: '',
                        mobile_phone: this.form.mobile,
                        last_conversion: {
                            source: "Contato do Site"
                        },
                        custom_fields: {
                            utm_content: "",
                            utm_medium: "",
                            utm_source: "",
                            utm_campaign: "",
                            utm_term: ""
                        },
                        tags: [],
                        notes: [
                            this.form.message
                        ]
                    }
                ]
            };
            // Chamada fetch para enviar os dados
            fetch('https://app.pipe.run/webservice/integradorJson?hash=544d2948-a269-465f-835a-6ad65f65c1e0', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            })
                .then(response => {
                    if (response.ok) {
                        this.$mensagemSucesso("Orçamento solicitado com sucesso.")
                        this.dialog = false;
                        this.clearForm();
                    } else {
                        throw new Error('Erro ao enviar os dados.');
                    }
                })
                .catch(error => {
                    console.error('Erro:', error);
                });
            }
        },
        clearForm() {
            this.form = {
                name: '',
                email: '',
                company: '',
                cityName: '',
                cityState: '',
                mobile: '',
                message: ''
            };
        },
        openDialog(item) {
            this.selectedItem = item;
            this.form.message = "Olá, tenho interesse no produto: " + item.proNomeProduto;
            this.dialog = true; // Abre o diálogo
        },
        stripHtml(htmlString) {
            const doc = new DOMParser().parseFromString(htmlString, 'text/html');
            return doc.body.textContent || "";
        },
        carregaMetas() {
            if (this.Produto && this.Produto.proTexto3) {
                const keywords = this.stripHtml(this.Produto.proTexto3);
                useHead({
                    title: this.Produto.proNomeProduto + ' - Seleto Industrial Máquinas para Industria Alimentícia',
                    meta: [
                        {
                            name: 'keywords',
                            content: keywords
                        }
                    ]
                });
            }
        },
        show(produtoimgs, startIndex = 0) {
            this.imagesForGallery = produtoimgs.map(element => ({
                src: element.pimUrlImagem
            }));
            this.$viewerApi({
                images: this.imagesForGallery,
                options: {
                  initialViewIndex: startIndex} // Definindo o índice inicial
            });
        },
        formatarValor(valor) {
            return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        },
        AdicionaAvulso(produtoAvulsoAdicionado){
           let dadosArmazenados = localStorage.getItem(this.$DadosCompra);
            if (dadosArmazenados) {
                dadosArmazenados = JSON.parse(dadosArmazenados);
                dadosArmazenados.avulsos.push(produtoAvulsoAdicionado.proProdutosAvulso);
                localStorage.setItem(this.$DadosCompra, JSON.stringify(dadosArmazenados));
                this.vProdutosExtras.push(produtoAvulsoAdicionado.proProdutosAvulso)
                this.calculatotal(this.Produto)
            }
        },
        ExcluiAvulso(index) {
        this.vProdutosExtras.splice(index, 1);
        let dadosArmazenados = localStorage.getItem(this.$DadosCompra);
       
        if (dadosArmazenados) {
            dadosArmazenados = JSON.parse(dadosArmazenados);
            dadosArmazenados.avulsos.splice(index, 1);
            localStorage.setItem(this.$DadosCompra, JSON.stringify(dadosArmazenados));
            this.calculatotal(this.Produto);
        }
       },
       AdicionaCarrinho(){
            let dadosArmazenados = localStorage.getItem(this.$DadosCompra);
            if (dadosArmazenados) {
                dadosArmazenados = JSON.parse(dadosArmazenados);
                dadosArmazenados.produtos.push(this.Produto);
                localStorage.setItem(this.$DadosCompra, JSON.stringify(dadosArmazenados));
                this.$router.push('/carrinho')
            }
       },
    },
    created() {
        axios.get('/Process/InsInstitucional/institucional/27/imagemtopo')
            .then(response => {
                this.informacoestopo = response.data;
            })
            .catch(error => {
                console.error(error);
            });

        let dadosArmazenados = localStorage.getItem(this.$DadosCompra);
        if (!dadosArmazenados) {
            dadosArmazenados = this.DadosCompra;
            localStorage.setItem(this.$DadosCompra, JSON.stringify(dadosArmazenados))
        }
        else {
            dadosArmazenados = JSON.parse(dadosArmazenados);

            if (dadosArmazenados.avulsos!=''){
                this.vProdutosExtras = dadosArmazenados.avulsos;
            }
        }

        axios.get('/Process/InsInstitucional/institucional/19/callaction')
            .then(response => {
                this.infocall = response.data;
            })
            .catch(error => {
                console.error(error);
            });

        if (this.id != null && this.id != '') {
            axios.get('/Process/ProProdutos/GetById/' + this.id)
                .then(response => {
                    this.Produto = response.data;
                    this.carregaMetas();
                    console.log('this.Produto')
                    console.log(this.Produto)
                    if (this.Produto.proProdutosImagens!=''){
                        this.ProdutoImg = this.Produto.proProdutosImagens.filter(x=> x.pimVisivel).sort((a, b) => {
                                                                            const valorA = parseInt(a.pimOrdem) || 0;
                                                                            const valorB = parseInt(b.pimOrdem) || 0;
                                                                            return valorA - valorB;
                                                                            });

                      this.ProdutoImg.forEach(element => {
                        element.pimUrlImagem = this.$imgURL +  element.pimUrlImagem
                      });
                        
                    }
                    else{
                         if (this.Produto.proCampoExtra5!= ""){
                            this.ProdutoImg.push({pimUrlImagem: this.Produto.proCampoExtra5});
                         }
                         if (this.Produto.proCampoExtra7!= ""){
                            this.ProdutoImg.push({pimUrlImagem: this.Produto.proCampoExtra7});
                         }
                         if (this.Produto.proCampoExtra8!= ""){
                            this.ProdutoImg.push({pimUrlImagem: this.Produto.proCampoExtra8});
                         }
                         if (this.Produto.proCampoExtra9!= ""){
                            this.ProdutoImg.push({pimUrlImagem: this.Produto.proCampoExtra9});
                         }
                    }

                })
                .catch(error => {
                    console.error(error);
                });

                axios.get('/Process/ProSegmentos/GetAll')
                .then(response => {
                    this.Segmentos = response.data;
                    this.SegmentosMenu = this.Segmentos.filter(x => x.psgIdPai == '' && x.psgVisivel).sort((a, b) => {
                        const nomeA = a.psgNomeSegmento || "";
                        const nomeB = b.psgNomeSegmento || "";
                        return nomeA.localeCompare(nomeB);
                    });

                })
                .catch(error => {
                    console.error(error);
                });
        }
    },
}
</script>

<style>.hhss {
    display: none;
}

.cortable{
    background-color: #f7f7f7;
}

.sli p {
    color: #ede3e3 !important;
}

@media (max-width:767px) {
    .fontcallT{
        font-size: 30px;
    }
    .fontcallS{
        font-size: 20px;
    }
}

@media (min-width:768px) and (max-width:991px) {
    .fontcallT{
        font-size: 30px;
    }
    .fontcallS{
        font-size: 20px;
    }
}

@media (min-width:992px) and (max-width:1199px) {
    .fontcallT{
        font-size: 30px;
    }
    .fontcallS{
        font-size: 20px;
    }
}

@media (min-width:1200px) {
    .fontcallT{
        font-size: 45px;
    }
    .fontcallS p{
        font-size: 20px;
    }
}


</style>
